export function checkOverflow(textContainer) {
  if (textContainer) return textContainer.offsetHeight < textContainer.scrollHeight || textContainer.offsetWidth < textContainer.scrollWidth;
  return false;
}